<template>
  <v-card data-testid="custom-date-range-form">
    <v-card-title class="primary white--text">
      <span class="headline">{{ $t('printTickets') }}</span>
      <v-spacer/>
      <Icon
        icon="mdi-close"
        iconColor="white"
        elementId="ticket-date-close"
        :large="true"
        :small="false"
        :tooltipText="$t('close')"
        @icon-clicked="$emit('close')"
      />
    </v-card-title>
    <v-card-text>
      <FormWrapper
        ref="form"
        formRef="CustomTicketDateRangeForm"
        buttonId="save-custom-ticket-date-range-form"
        :lazyValidation="true"
        :disabled="isButtonDisabled"
        :buttonText="$t('printTickets')"
        @submit="setDateButtonPressed"
      >
        <v-container fluid class="py-6">
          <v-row>
            <v-col cols="12">
              <DatePicker
                elementId="tract-ticket-start"
                :dateLabel="$t('startDate')"
                :allowFuture="false"
                @valid-date="(val) => {isValidStartDate = val}"
                @date-picked="startDateChosen"
                :focusInput="focusStartDate"
                :startDate="initialStartDate"
              />
            </v-col>
            <v-col cols="12">
              <DatePicker
                elementId="tract-ticket-end"
                :dateLabel="$t('endDate')"
                :allowFuture="false"
                @valid-date="(val) => {isValidEndDate = val}"
                @date-picked="endDateChosen"
              />
            </v-col>
          </v-row>
        </v-container>
      </FormWrapper>
    </v-card-text>
  </v-card>
</template>

<script>
import fieldRules from '@/utils/rules'
import moment from 'moment'
import { localToUTC, localToCompanyOffsetEndOfDay } from '@/utils/DateFormatter.js'

export default {
  name: 'CustomTicketDateRangeForm',

  components: {
    DatePicker: () => import('@/components/helper/DatePicker.vue'),
    Icon: () => import('@/components/helper/Icon.vue'),
    FormWrapper: () => import('@/components/core/FormWrapper.vue')
  },

  data: () => ({
    rules: fieldRules.rules,
    isValidStartDate: true,
    isValidEndDate: true,
    chosenSinceDate: '',
    chosenUntilDate: '',
    initialStartDate: moment().subtract(2, 'week'),
    focusStartDate: false
  }),

  computed: {
    isButtonDisabled () {
      return !(this.isValidStartDate && this.isValidEndDate)
    },

    dateRangeObj () {
      return {
        sinceTime: this.chosenSinceDate ? moment(this.chosenSinceDate).format() : moment(this.sinceTime).format(),
        untilTime: moment(this.chosenUntilDate).format()
      }
    }
  },

  mounted () {
    this.$nextTick(() => {
      this.focusStartDate = true
    })
  },

  methods: {
    startDateChosen (date) {
      this.chosenSinceDate = date
    },

    endDateChosen (date) {
      this.chosenUntilDate = date
    },

    setDateButtonPressed () {
      const differenceInDays = moment(this.chosenUntilDate).diff(moment(this.chosenSinceDate), 'days')

      if (differenceInDays < 0) {
        this.setSnackError(this.$t('startDateBeforeEndDate'))
        return
      }

      const dateRange = {
        sinceTime: this.chosenSinceDate ? localToUTC(this.chosenSinceDate) : null,
        untilTime: this.chosenUntilDate ? localToCompanyOffsetEndOfDay(this.chosenUntilDate) : null
      }
      this.$emit('dates-chosen', dateRange)
    }
  }
}
</script>
